import { api } from "./api";

const CHUNK = 4 * 1024 * 1024; // 4MB chunks to slip under proxy body limits
const CONCURRENCY = 4;          // upload several chunks at once for speed

// Uploads a (large) video file to object storage in parallel chunks. Returns the served /api/files URL.
export async function uploadVideoChunked(file, onProgress) {
  const { data: init } = await api.post("/upload-video/init");
  const uploadId = init.upload_id;
  const total = file.size;

  const chunks = [];
  let index = 0;
  for (let start = 0; start < total; start += CHUNK) {
    chunks.push({ index: index++, start, end: Math.min(start + CHUNK, total) });
  }

  let sent = 0;
  let cursor = 0;
  const worker = async () => {
    while (cursor < chunks.length) {
      const c = chunks[cursor++];
      const blob = file.slice(c.start, c.end);
      const fd = new FormData();
      fd.append("upload_id", uploadId);
      fd.append("index", String(c.index));
      fd.append("chunk", blob, "chunk");
      await api.post("/upload-video/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
      sent += c.end - c.start;
      onProgress && onProgress(Math.round((sent / total) * 100));
    }
  };
  await Promise.all(Array.from({ length: Math.min(CONCURRENCY, chunks.length) }, worker));

  const { data } = await api.post("/upload-video/complete", { upload_id: uploadId, filename: file.name || "clip.mp4" });
  return data.url;
}
